import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PROJECTS = [
  { url: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=900&q=80", label: "Corporate Floor", category: "Commercial" },
  { url: "https://images.pexels.com/photos/4239031/pexels-photo-4239031.jpeg?w=900", label: "Apartment Turnover", category: "Move-Out" },
  { url: "https://images.pexels.com/photos/3935331/pexels-photo-3935331.jpeg?w=900", label: "New Build Final Clean", category: "Post-Construction" },
  { url: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=900&q=80", label: "Medical Office", category: "Commercial" },
  { url: "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?w=900", label: "Luxury Kitchen Reset", category: "Move-In" },
  { url: "https://images.pexels.com/photos/271643/pexels-photo-271643.jpeg?w=900", label: "Glass High-Rise", category: "Post-Construction" },
];

export const GallerySection = () => (
  <section className="py-24 lg:py-32 bg-[#080808]">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-14 gap-6">
        <Reveal className="max-w-2xl">
          <div className="overline text-[#D4AF37] mb-4">Recent Work</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
            Spaces we've
            <br />
            <span className="gold-grad-text italic">transformed.</span>
          </h2>
        </Reveal>
        <Reveal delay={150}>
          <a href="#quote" className="text-[#D4AF37] inline-flex items-center gap-1 group self-start">
            Book your space
            <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-4">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.label} delay={i * 80}>
            <div className="group relative overflow-hidden rounded-2xl border border-white/5 aspect-square">
              <img
                src={p.url}
                alt={p.label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute inset-0 p-5 flex flex-col justify-end">
                <div className="overline text-[#D4AF37] mb-1">{p.category}</div>
                <div className="font-serif-display text-xl text-white">{p.label}</div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
